import TextSimple from "@/src-refactor/modules/shared/components/typography/text-simple/TextSimple";
import { usePropertyDetailPage } from "../../context/PropertyDetailPageContext";
import { Button } from "@mui/material";
import styled from "@emotion/styled";
import DropboxIcon from "@icons-rf/videos/dropbox.svg?react";
import DriveIcon from "@icons-rf/videos/google-drive.svg?react";
import MxDetailCard from "@rf-l1/page/details/MxDetailCard";
import MxDetailSubTitle from "@rf-l1/page/details/MxDetailSubTitle";
import Grid from "@mui/material/Grid";

const VirtualFolders = () => {
  const propertyData = usePropertyDetailPage();

  const openLinkInNewTab = (url: string) => {
    window.open(url, "_blank");
  };

  if (
    !propertyData.virtualFolders?.dropbox &&
    !propertyData.virtualFolders?.google_drive
  ) {
    return <></>;
  }

  return (
    <MxDetailCard>
      <Grid container alignItems="center" gap={2}>
        <Grid container alignItems="center">
          <MxDetailSubTitle label="Carpetas virtuales" />
        </Grid>

        <Grid container alignItems="center" gap={2}>
          {propertyData.virtualFolders?.dropbox && (
            <ButtonIcon
              variant="outlined"
              startIcon={<DropboxIcon width={20} height={20} />}
              onClick={() =>
                openLinkInNewTab(propertyData.virtualFolders?.dropbox ?? "")
              }
            >
              Dropbox
            </ButtonIcon>
          )}

          {propertyData.virtualFolders?.google_drive && (
            <ButtonIcon
              variant="outlined"
              startIcon={<DriveIcon width={20} height={20} />}
              onClick={() =>
                openLinkInNewTab(propertyData.virtualFolders?.google_drive ?? "")
              }
            >
              Drive
            </ButtonIcon>
          )}
        </Grid>
      </Grid>
    </MxDetailCard>
  );
};

export default VirtualFolders;

const ContainerButtons = styled.div`
  margin-top: 10px;
  display: flex;
  gap: 20px;
`;

const ButtonIcon = styled(Button)`
  font-size: var(--fs-text-x-small);
  width: 150px;
  text-transform: none;
  font-weight: bold;
  justify-content: start;
  padding-right: 50px;
  border-radius: 20px;
  font-family: var(--ff-inter);
  color: var(--m-color-blue-03);
`;
